import { type UseQueryResult, useQuery } from 'react-query';
import { ServicedCompanyService } from '../../services/wealthlane-customer-services/services/ServicedCompanyService';

export interface ServicedCompanyOption {
  label: string;
  value: string;
  domain: string;
}

const useGetServicedMyCompanies = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<ServicedCompanyOption[] | undefined, unknown> => {
  const servicedMyCompanies = useQuery(
    ['getServicedCompanyMyCompanies'],
    async () => {
      return await handleRequest(ServicedCompanyService.getApiCustomerApiAppServicedCompanyMyCompanies());
    },
    {
      select: (data) => {
        return data?.map((item) => ({
          label: item.name ?? '',
          value: item.id ?? '',
          domain: '',
        }));
      },
      cacheTime: 1000 * 60 * 5,
    }
  );

  return servicedMyCompanies;
};

export default useGetServicedMyCompanies;
